import { useState } from 'react';
import { Ripple } from 'primereact/ripple';
import { v4 as uuid } from 'uuid';
import { classNames } from 'primereact/utils';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { ConfirmModal } from 'admin/components/SureToDeleteModal';
import { Images } from 'assets/images';
import { SampleDiv, SampleSpan } from 'admin/layout/styled';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import {
  ACTIVE_TABS,
  BLOCKED,
  BLOCKED_TEXT,
  CLASSNAMES,
  MODAL_CONSTANTS,
  NOT_BLOCKED,
  OFF,
  ON,
  THREE_DOTS,
  VISIBILITY_TEXT,
} from 'admin/utils/contants';
import {
  TableWrapper,
  TableImageContainer,
  ColumnTable,
  Table,
  DefaultSpan,
  DefaultSecondSpan,
} from './styled';

export const MainTable = ({
  OpenEditModal,
  _data,
  activeTab,
  setDelete,
  headerData,
  openCreateModal,
  setChangeData,
  selected,
  setRequestData,
  setMyRequests,
  setSelectedItems,
  selectedItems,
  handleViewModal,
  setViewModalData,
}) => {
  const [deletingRow, setDeletingRow] = useState({});
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  const CloseModal = () => {
    setIsOpen(false);
  };

  const renderStatusBodyTemplate = (rowData) => (
    <>
      {rowData.blocked ? (
        <DefaultSpan
          buttonStyle={rowData.blocked === NOT_BLOCKED ? NOT_BLOCKED : BLOCKED}
        >
          {rowData.blocked}
        </DefaultSpan>
      ) : null}

      {rowData.visibility ? (
        <DefaultSecondSpan buttonStyle={rowData.visibility === ON ? ON : OFF}>
          {rowData.visibility}
        </DefaultSecondSpan>
      ) : null}
    </>
  );

  const pagination = {
    layout: CLASSNAMES.PAGINATION_ITEMS_CLASSNAMES,
    PageLinks: (options) => {
      if (
        (options.view.startPage === options.page && options.view.startPage !== 0) ||
        (options.view.endPage === options.page &&
          options.page + 1 !== options.totalPages)
      ) {
        const className = classNames(options.className, { 'p-disabled': true });

        return (
          <SampleSpan className={className} userSelect>
            {THREE_DOTS}
          </SampleSpan>
        );
      }

      return (
        <SampleDiv
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </SampleDiv>
      );
    },
  };

  const handleEdit = (event) => {
    setChangeData(event);
    openCreateModal(MODAL_CONSTANTS.EDIT_USER);
  };

  const openDeleteModal = (rowData) => {
    setIsOpen(true);
    setDeletingRow(rowData);
  };

  const openViewModal = (rowData) => {
    handleViewModal();
    setViewModalData(rowData);
  };

  const handleDelete = () => {
    setDelete(() => _data.filter((item) => item?.id !== deletingRow?.id));
    setIsOpen(false);
  };

  const handleAddToMyRequests = (rowData) => {
    setRequestData(() => _data.filter((item) => item.id !== rowData?.id));
    setMyRequests((prevState) => [...prevState, rowData]);
  };

  const handleUnAssignFromMyRequests = (rowData) => {
    setMyRequests(() => _data.filter((item) => item.id !== rowData?.id));
    setRequestData((prevState) => [...prevState, rowData]);
  };

  const viewRequest = (event) => {
    setChangeData(event);
    openCreateModal();
  };

  const modalHeaderTitles = (element) => {
    switch (element) {
      case 'birthdate':
        return 'Birth Date';
      case 'id':
        return 'ID';
      case 'request_limit':
        return 'Request Limit';
      case 'answer_type':
        return 'Answer Type';
      default:
        return element;
    }
  };
  const renderImagesBodyTemplate = (rowData) => {
    switch (activeTab) {
      case ACTIVE_TABS.CUSTOMERS:
      case ACTIVE_TABS.SYSTEM_USERS:
        return (
          <TableImageContainer>
            <img
              src={Images.editButton}
              onClick={() => handleEdit(rowData)}
              alt="image"
            />
            <img
              src={Images.deleteButton}
              alt="image"
              onClick={() => openDeleteModal(rowData)}
            />
            <img src={Images.resetVector} alt="image" />
            <img src={Images.userVector} alt="image" />
          </TableImageContainer>
        );
      case MODAL_CONSTANTS.ALL_REQUESTS:
        return (
          <TableImageContainer>
            <img
              src={Images.eyeSilverIcon}
              onClick={() => viewRequest(rowData)}
              alt="image"
            />
            <img
              src={Images.doneIcon}
              alt="image"
              onClick={() => handleAddToMyRequests(rowData)}
            />
          </TableImageContainer>
        );
      case MODAL_CONSTANTS.MY_REQUESTS:
        return (
          <TableImageContainer>
            <img src={Images.eyeSilverIcon} alt="image" />
            <img
              src={Images.closeSilverIcon}
              alt="image"
              onClick={() => handleUnAssignFromMyRequests(rowData)}
            />
          </TableImageContainer>
        );
      case MODAL_CONSTANTS.HOT_OFFERS:
        return (
          <TableImageContainer>
            <img
              src={Images.deleteButton}
              alt="image"
              onClick={() => openDeleteModal(rowData)}
            />
            <img
              src={Images.eyeSilverIcon}
              onClick={() => handleViewModal(rowData)}
            />
          </TableImageContainer>
        );
      case ACTIVE_TABS.QUESTIONS:
        return (
          <TableImageContainer>
            <img
              src={Images.editButton}
              onClick={() => handleEdit(rowData)}
              alt="image"
            />
            <img
              src={Images.deleteButton}
              alt="image"
              onClick={() => openDeleteModal(rowData)}
            />
          </TableImageContainer>
        );
      case ACTIVE_TABS.PACKAGES:
        return (
          <TableImageContainer>
            <img
              src={Images.editButton}
              alt="image"
              onClick={() => OpenEditModal(rowData)}
            />
            <img
              src={Images.deleteButton}
              alt="image"
              onClick={() => openDeleteModal(rowData)}
            />
            <img
              src={Images.eyeSilverIcon}
              alt="image"
              onClick={() => openViewModal(rowData)}
            />
            <img src={Images.silverStarsIcon} alt="image" />
          </TableImageContainer>
        );
      default:
        return null;
    }
  };

  return (
    <TableWrapper>
      {isOpen ? (
        <SampleDiv ref={ref}>
          <ConfirmModal CloseModal={CloseModal} handleDelete={handleDelete} />
        </SampleDiv>
      ) : null}
      <Table
        value={_data}
        sortMode="multiple"
        selection={selectedItems}
        responsiveLayout="scroll"
        onSelectionChange={(e) => setSelectedItems(e.value)}
        paginator
        dataKey="id"
        paginatorTemplate={pagination}
        rows={selected}
      >
        <ColumnTable selectionMode="multiple" headerStyle={{ width: '3em' }} />
        {headerData.map((element) => (
          <ColumnTable
            key={uuid()}
            field={element}
            header={() => modalHeaderTitles(element)}
            sortable
            bodyStyle={element === 'email' ? { width: '260px' } : null}
            body={
              element === BLOCKED_TEXT || element === VISIBILITY_TEXT
                ? (e) => renderStatusBodyTemplate(e)
                : null
            }
          />
        ))}

        <ColumnTable
          field="actions"
          header="Actions"
          body={(e) => renderImagesBodyTemplate(e)}
        />
      </Table>
    </TableWrapper>
  );
};
